import { createElement, Component } from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { equals } from 'ramda';
import PropTypes from 'prop-types';

import ReduxFormWrapper from 'containers/ReduxFormWrapper';

class ProfileEditable extends Component {
  componentWillReceiveProps({ formValues: nextValues }) {
    const { formValues, setValues } = this.props;
    if (formValues && nextValues && !equals(formValues, nextValues)) {
      setValues(nextValues);
    }
  }

  render() {
    const { name, children, formValues = {} } = this.props;
    const initialValues = this.props.initial ? this.props.initial : {};
    return createElement(ReduxFormWrapper, { form: name, editing: true, formValues, initialValues }, children);
  }
}

const mapStateToProps = (state, ownProps) => ({ formValues: getFormValues(ownProps.name)(state) });

ProfileEditable.propTypes = {
  name: PropTypes.string,
  children: PropTypes.element,
  formValues: PropTypes.object,
  initial: PropTypes.object,
  setValues: PropTypes.func,
};

export default connect(mapStateToProps)(ProfileEditable);
